import React, { Fragment } from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { Home } from 'react-feather';
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import GetButtons from '../../components/common/getButtons';

const Breadcrumbs = (props) => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title" >
          <Row  style={{'paddingTop': '10px'}}>
            <Col xs="6">
            <span className='mr-2' style={{textDecoration:"underline", cursor: "pointer"}} onClick={goBack}><i className="fa fa-arrow-left " aria-hidden="true"></i>Back</span>
            {/* {props.refresh && props.chasisFetchTrigger ? <span className='mr-2' style={{textDecoration:"underline", cursor: "pointer"}} onClick={props.refresh}>Reset</span>: ""} */}
              {/* <h3> { props.sub_header ? props.sub_header : props.title } <br /></h3> */}
              <h5> { props.child ? props.child : props.title } <br /></h5>
            </Col>
            <Col xs="6">
              <Breadcrumb>
                <BreadcrumbItem><Link to={`${process.env.PUBLIC_URL}/dashboard/default/`}><Home /></Link></BreadcrumbItem>
                {props.parent && <BreadcrumbItem>{props.parent}</BreadcrumbItem> }
                <BreadcrumbItem active >{props.title}</BreadcrumbItem>
                { props.child ? <BreadcrumbItem active>{props.child}</BreadcrumbItem> : '' }
                
              </Breadcrumb>
             
            </Col>
          </Row>
          <Row className='mb-0'>
          <Col xs="6">

          {props.sub_header ? <small style={{ fontSize: "17px" }}>
                  {props.sub_header}
              </small> : null}
              </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
}

export default Breadcrumbs;